{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "Etkin",
          "DISABLED": "Devre dışı"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Tarafından gönderildi",
          "BOT": "Bot",
          "FROM": "dan",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "İptal Et",
        "CREATE_BUTTON_TEXT": "Yarat",
        "FORM": {
          "TITLE": {
            "LABEL": "Başlık",
            "PLACEHOLDER": "Lütfen kampanya başlığını giriniz",
            "ERROR": "Başlık gerekli"
          },
          "MESSAGE": {
            "LABEL": "Mesaj",
            "PLACEHOLDER": "Lütfen kampanya mesajı giriniz",
            "ERROR": "Mesaj gerekli"
          },
          "INBOX": {
            "LABEL": "Gelen Kutu Seç",
            "PLACEHOLDER": "Gelen Kutu Seç",
            "ERROR": "Gelen kutusu seçimi gerekli"
          },
          "SENT_BY": {
            "LABEL": "Tarafından gönderildi",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "Gönderen bilgisi gerekli"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Lütfen URL giriniz",
            "ERROR": "Lütfen geçerli bir adres girin",
            "URL_IS_REGEXP": "Değer bir düzenli ifadedir"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Yayım süresi(saniye)",
            "PLACEHOLDER": "Lütfen saat seçiniz",
            "ERROR": "Yayın süresi seçiniz"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "Kampanyayı başlat",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Sadece çalışma saatleri içerisinde tetikle"
          },
          "BUTTONS": {
            "CREATE": "Yarat",
            "CANCEL": "İptal Et"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "Bir hata oluştu, lütfen tekrar deneyin."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "Bir hata oluştu, lütfen tekrar deneyin."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Tamamlandı",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "İptal Et",
        "CREATE_BUTTON_TEXT": "Yarat",
        "FORM": {
          "TITLE": {
            "LABEL": "Başlık",
            "PLACEHOLDER": "Lütfen kampanya başlığını giriniz",
            "ERROR": "Başlık gerekli"
          },
          "MESSAGE": {
            "LABEL": "Mesaj",
            "PLACEHOLDER": "Lütfen kampanya mesajı giriniz",
            "ERROR": "Mesaj gerekli"
          },
          "INBOX": {
            "LABEL": "Gelen Kutu Seç",
            "PLACEHOLDER": "Gelen Kutu Seç",
            "ERROR": "Gelen kutusu seçimi gerekli"
          },
          "AUDIENCE": {
            "LABEL": "Kitle",
            "PLACEHOLDER": "Müşteri etiketlerini seçin",
            "ERROR": "Kitle seçimi gerekli"
          },
          "SCHEDULED_AT": {
            "LABEL": "Planlanan zaman",
            "PLACEHOLDER": "Lütfen saati seçiniz",
            "ERROR": "Planlanan zaman seçimi gerekli"
          },
          "BUTTONS": {
            "CREATE": "Yarat",
            "CANCEL": "İptal Et"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "Bir hata oluştu, lütfen tekrar deneyin."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Silmek istediğinizden emin misiniz?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "Sil",
      "API": {
        "SUCCESS_MESSAGE": "Kampanya başarıyla silindi",
        "ERROR_MESSAGE": "Bir hata oluştu, lütfen tekrar deneyin."
      }
    }
  }
}
